import { $fetch } from '@/boot/fetch'
import { replacePathTokens } from '@/utils/routes.util'

const ENDPOINT = '/retailers/{{retailerId}}/settings'

export default {
  /**
   * Update retailer settings
   * @param {String} retailerId - The retailer ID
   * @param {Object} body - Settings body
   * @return {Promise}
   */
  update(retailerId, body) {
    return $fetch.peg(replacePathTokens(ENDPOINT, { retailerId }), {
      method: 'PUT',
      body,
    })
  },
}
